export const getSearchPageUrl = (term: string) => `/search?q=${encodeURIComponent(term)}`
